import styled from "styled-components";
import { FLOATING_WIDGET_POSITIONS } from "./constants";

export const Container = styled.div({
    width: "100vw",
    maxWidth: "100vw",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    height: "100%",
});

export const MenuFlexContainer = styled.div({
    flexGrow: 1,
    overflowY: "scroll",
    // display: "flex",
    // gap: "80px",
    // flexDirection: "column",
    display: "flow",
});

export const BottomWidget = styled.div({
    height: 60,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    "@supports (height: var(--sab))": {
        height: "calc(var(--sab) + 60px)",
    },
});

export const FloatingWidgetContainer = styled.div(({ theme }) => ({
    position: "absolute",
    bottom: `calc(var(--sab, 0px) + ${theme.spacing.medium})`,
    width: "100%",
    padding: `0 ${theme.spacing.medium}`,
    zIndex: 2,
}));

export const OverLayLoader = styled("div")(({ theme }) => ({
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.colors[theme.colorMode].canvas_Primary,
}));

interface IFloatingWidgetPositionProps {
    ifCartItemAvailable: boolean;
}

export const FloatingWidgetPosition = styled.div<IFloatingWidgetPositionProps>(
    ({ ifCartItemAvailable }) => ({
        position: "fixed",
        bottom: `calc(var(--sab, 0px) + ${
            ifCartItemAvailable
                ? FLOATING_WIDGET_POSITIONS.BOTTOM_WITH_CART
                : FLOATING_WIDGET_POSITIONS.BOTTOM_WITHOUT_CART
        })`,
        right: "0px",
        width: "100vw",
        zIndex: 300,
    })
);
